// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bold {
    font-weight: bold;
}
.italic {
    font-style: italic;
}
.underline {
    text-decoration: underline;
}
img {
     max-width:100%;
     height:auto;
 }
`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/form-view/request-view/request-view.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;KACK,cAAc;KACd,WAAW;CACf","sourcesContent":[".bold {\n    font-weight: bold;\n}\n.italic {\n    font-style: italic;\n}\n.underline {\n    text-decoration: underline;\n}\nimg {\n     max-width:100%;\n     height:auto;\n }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
